<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">

    <header class="bb-page-header">
      <div class="bb-page-title-block">
                        <span class="bb-eyebrow">{{ 'add service' | transloco }}</span>
        <h2 class="bb-page-title">{{ "add service" | transloco }}</h2>
      </div>
    </header>

    <div class="bb-card bb-p-20">
      <form [formGroup]="data" (ngSubmit)="onSubmit()">
        <div class="bb-form-grid">

          @if(submitted && data.invalid) {
          <div class="bb-form-alert bb-field-full" role="alert">
            {{ 'Review the required fields before saving' | transloco }}
            @if(getMissingRequiredCount() > 0) {
            <span>
              ({{ getMissingRequiredCount() }} {{ 'required fields' | transloco }})
            </span>
            }
          </div>
          }

          <div class="bb-field bb-field-full">
            <label class="bb-label">{{ 'Select Image' | transloco }}</label>

            <div class="bb-upload-card">
              <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event)" hidden />

              <div class="bb-upload-area" (click)="fileInput.click()">

                <div *ngIf="!selectedFile" class="bb-upload-placeholder">
                  <span class="bb-upload-icon">
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                      <rect x="3" y="7" width="18" height="14" rx="3" stroke="#2A7DE1" stroke-width="2.5" />
                      <circle cx="12" cy="14" r="3.5" stroke="#2A7DE1" stroke-width="2.5" />
                      <path d="M8 7L9.5 5H14.5L16 7" stroke="#2A7DE1" stroke-width="2.5" />
                    </svg>
                  </span>

                  <p class="bb-upload-title">{{ 'Select Image' | transloco }}</p>
                  <small class="bb-upload-sub">{{ 'PNG / JPG' | transloco }}</small>
                </div>

                <div *ngIf="selectedFile" class="bb-preview-container">
                  <img [src]="selectedFile ? (selectedFilePreview | safeUrl) : ''" [alt]="'Preview' | transloco" class="bb-preview-img" />

                  <button
                    type="button"
                    class="bb-btn bb-btn-secondary bb-btn-sm"
                    (click)="fileInput.click(); $event.stopPropagation()"
                  >
                    {{ "change image" | transloco }}
                  </button>
                </div>

              </div>
            </div>
          </div>

          <div class="bb-field">
            <label class="bb-label" for="name_en">{{ 'Name' | transloco }}</label>
            <input
              class="bb-input"
              type="text"
              id="name_en"
              formControlName="name_en"
              placeholder="{{ 'Name' | transloco }}"
              [(ngModel)]="name_en"
              [ngClass]="{
                'is-invalid': data.get('name_en')?.touched && data.get('name_en')?.invalid,
                'is-valid': data.get('name_en')?.touched && data.get('name_en')?.valid
              }"
            />
            @if(shouldShowError('name_en')) {
            <div class="bb-field-error">{{ getErrorMessage('name_en', ('Name' | transloco)) }}</div>
            }
          </div>

          <div class="bb-field">
            <label class="bb-label" for="name_ar">{{ 'NameAr' | transloco }}</label>
            <input
              class="bb-input"
              type="text"
              id="name_ar"
              formControlName="name_ar"
              placeholder="{{ 'NameAr' | transloco }}"
              [(ngModel)]="name_ar"
              [ngClass]="{
                'is-invalid': data.get('name_ar')?.touched && data.get('name_ar')?.invalid,
                'is-valid': data.get('name_ar')?.touched && data.get('name_ar')?.valid
              }"
            />
            @if(shouldShowError('name_ar')) {
            <div class="bb-field-error">{{ getErrorMessage('name_ar', ('NameAr' | transloco)) }}</div>
            }
          </div>

          <div class="bb-field">
            <label class="bb-label" for="product_info_ar">{{ 'Description ar' | transloco }}</label>
            <input
              class="bb-input"
              type="text"
              id="product_info_ar"
              formControlName="product_info_ar"
              placeholder="{{ 'Description ar' | transloco }}"
              [(ngModel)]="product_info_ar"
              [ngClass]="{
                'is-invalid': data.get('product_info_ar')?.touched && data.get('product_info_ar')?.invalid,
                'is-valid': data.get('product_info_ar')?.touched && data.get('product_info_ar')?.valid
              }"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="product_info_en">{{ 'Description en' | transloco }}</label>
            <input
              class="bb-input"
              type="text"
              id="product_info_en"
              formControlName="product_info_en"
              placeholder="{{ 'Description en' | transloco }}"
              [(ngModel)]="product_info_en"
              [ngClass]="{
                'is-invalid': data.get('product_info_en')?.touched && data.get('product_info_en')?.invalid,
                'is-valid': data.get('product_info_en')?.touched && data.get('product_info_en')?.valid
              }"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label">{{ 'pet type' | transloco }}</label>
            <div class="bb-select-wrap">
              <select
                class="bb-select"
                formControlName="pet_type"
                [(ngModel)]="pet_type"
                [ngClass]="{
                  'is-invalid': data.get('pet_type')?.touched && data.get('pet_type')?.invalid,
                  'is-valid': data.get('pet_type')?.touched && data.get('pet_type')?.valid
                }"
              >
                <option value="">{{ '-- اختار --' | transloco }}</option>
                <option value="0"> {{ "adult" | transloco }}</option>
                <option value="1"> {{ "kitten" | transloco }}</option>
                <option value="2"> {{ "sterilized" | transloco }}</option>
                <option value="3"> {{ "persian" | transloco }}</option>
                <option value="4"> {{ "puppy" | transloco }}</option>
                <option value="5"> {{ "birds" | transloco }}</option>
                <option value="6">{{ "other" | transloco }} </option>
              </select>
            </div>
          </div>

          <div class="bb-field">
            <label class="bb-label">{{ "pet" | transloco }}</label>
            <div class="bb-select-wrap">
              <select
                class="bb-select"
                formControlName="pet"
                [(ngModel)]="pet"
                [ngClass]="{
                  'is-invalid': data.get('pet')?.touched && data.get('pet')?.invalid,
                  'is-valid': data.get('pet')?.touched && data.get('pet')?.valid
                }"
              >
                <option value="">{{ '-- اختار --' | transloco }}</option>
                <option value="0"> {{ "cats" | transloco }}</option>
                <option value="1"> {{ "dogs" | transloco }}</option>
                <option value="2"> {{ "birds" | transloco }}</option>
                <option value="4"> {{ "cats&dogs" | transloco }}</option>
                <option value="3">{{ "other" | transloco }} </option>
              </select>
            </div>
          </div>

          <div class="bb-field">
            <label class="bb-label" for="price">{{ 'Cost price' | transloco }}</label>
            <input
              class="bb-input"
              type="text"
              id="price"
              formControlName="price"
              placeholder="{{ 'Cost price' | transloco }}"
              [(ngModel)]="price"
              [ngClass]="{
                'is-invalid': data.controls['price'].touched && data.controls['price'].errors,
                'is-valid': data.controls['price'].touched && !data.controls['price'].errors,
                'is-touched': data.controls['price'].untouched && !data.controls['price'].errors,
              }"
            />
            @if(shouldShowError('price')) {
            <div class="bb-field-error">{{ getErrorMessage('price', ('Cost price' | transloco)) }}</div>
            }
          </div>

          <div class="bb-field">
            <label class="bb-label" for="pricea">{{ 'Selling price' | transloco }}</label>
            <input
              class="bb-input"
              type="text"
              id="pricea"
              formControlName="pricea"
              placeholder="{{ 'Selling price' | transloco }}"
              [(ngModel)]="pricea"
              [ngClass]="{
                'is-invalid': data.controls['pricea'].touched && data.controls['pricea'].errors,
                'is-valid': data.controls['pricea'].touched && !data.controls['pricea'].errors,
                'is-touched': data.controls['pricea'].untouched && !data.controls['pricea'].errors,
              }"
            />
            @if(shouldShowError('pricea')) {
            <div class="bb-field-error">{{ getErrorMessage('pricea', ('Selling price' | transloco)) }}</div>
            }
          </div>

          <div class="bb-field bb-field-full bb-mt-16">
            @if(isUpdatePage) {
            <button type="submit" class="bb-btn bb-btn-primary bb-w-100" [class.is-disabled]="data.invalid">
              {{ "Edit" | transloco }}
            </button>
            }@else {
            <button type="submit" class="bb-btn bb-btn-primary bb-w-100" [class.is-disabled]="data.invalid">
              {{ "Submit" | transloco }}
            </button>
            }
          </div>

        </div>
      </form>
    </div>

  </div>
</section>